import React, { useEffect, useState } from "react";
import { FormGroup } from "react-bootstrap";
import { TYPE_HYBRID } from "../../../constants";
import RegistrationFieldsList from "../RegistrationFields/RegistrationFieldsList";
import { getWidgetRegistrationFields } from "../../../../../../../api/player";
import { updateWidgetRegistrationField, updateWidgetRegistrationFieldsOrder } from "../../../../../../../api/cp/widgetRegistration";

const FieldsSequence = ({
    widgetKey,
    participationType,
    registrationType,
    onUpdatePreview,
}) => {
    const [fields, setFields] = useState([]);

    useEffect(() => {
        fetchRegistrationFields();
    }, []);

    async function fetchRegistrationFields() {
        try {
            const response = await getWidgetRegistrationFields(widgetKey);
            setFields(response);
        } catch (error) {
            console.error(error);
        }
    }

    const handleChangeField = async (id, payload) => {
        try {
            await updateWidgetRegistrationField(id, payload);
            fetchRegistrationFields();
            onUpdatePreview(true);
        } catch (error) {
            console.error(error);
        }
    };

    const handleUpdateFieldsOrder = async (list) => {
        setFields(list);
        try {
            const payload = list.map(({name, id}) => id ?? name);
            await updateWidgetRegistrationFieldsOrder(widgetKey, payload);
            fetchRegistrationFields();
            onUpdatePreview(true);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <FormGroup>
            {(participationType === TYPE_HYBRID && registrationType === TYPE_HYBRID) && (
                <p>
                    <i>
                        Поле "Формат участия" всегда располагается под полем "Почта". Последовательность для него менять нельзя
                    </i>
                </p>
            )}

            <RegistrationFieldsList
                registrationFields={fields}
                registrationType={registrationType}
                onUpdateField={handleChangeField}
                onUpdateOrder={handleUpdateFieldsOrder}
            />
        </FormGroup>
    );
};

export default FieldsSequence;
